import { observer } from 'mobx-react';
import { FC } from 'react';
import { cashbackStore } from '../../store/cashbackStore';
import { IEditCashback } from '../../types/cashback';
import { localeStore } from '~/mobx/localesStore';
import { TBooleanInNumber } from '~/types/main';
import CustomTooltip, { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from '~/view/components/Text/Text';

const CashbackAvailability: FC = observer((): JSX.Element => {
  const handleStatusChange = (state: TBooleanInNumber) => {
    const data: Partial<IEditCashback> = { state };
    if (!state) data.highest_priority = 0;
    cashbackStore.changeCashback(data);
  };

  const handleHighestPriorityChange = (highestPriority: TBooleanInNumber) => {
    cashbackStore.changeCashback({ highest_priority: highestPriority });
  };

  return (
    <div className="d-flex gap-40 mt-6">
      <div className="d-flex align-items-center">
        <CustomTooltip
          position={TOOLTIP_POSITION.PORTAL}
          show={cashbackStore.cashback.isActiveLimitReached || cashbackStore.cashback.isExpired}
          message={cashbackStore.cashback.isExpired ? 'expired_cashback_tooltip' : 'max_limit_of_active_cashbacks_reached_err'}
          duration={TOOLTIP_DURATION.EXTRA_LARGE}
        >
          <Switcher
            status={cashbackStore.cashback.state}
            onChange={handleStatusChange}
            disabled={cashbackStore.cashback.isActiveLimitReached || cashbackStore.cashback.isExpired}
          />
        </CustomTooltip>
        <Text
          text={localeStore.t('status')}
          type={TEXT.SWITCHER_LABEL}
          tooltip={{ message: 'cashback_status_toggle_hint', position: TOOLTIP_POSITION.PORTAL }}
        />
      </div>
      <div className="d-flex align-items-center">
        <Switcher status={cashbackStore.cashback.highest_priority} disabled={!cashbackStore.cashback.state} onChange={handleHighestPriorityChange} />
        <Text
          text={localeStore.t('cashback_set_highest_prority_toggle_label')}
          type={TEXT.SWITCHER_LABEL}
          tooltip={{ message: 'cashback_set_highest_prority_toggle_hint', position: TOOLTIP_POSITION.PORTAL }}
        />
      </div>
    </div>
  );
});

export default CashbackAvailability;
